import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ContestPopup from "@/components/ContestPopup";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AppLayout from "@/components/AppLayout";
import Dashboard from "@/pages/Dashboard";
import Copilot from "@/pages/Copilot";
import Transactions from "@/pages/Transactions";
import Goals from "@/pages/Goals";
import Investments from "@/pages/Investments";
import InvestPlan from "@/pages/InvestPlan";
import Reports from "@/pages/Reports";

function Protected({ children }) {
  const { user, checking } = useAuth();
  if (checking || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex gap-2">
          <span className="organic-dot h-3 w-3 rounded-full bg-primary" />
          <span className="organic-dot h-3 w-3 rounded-full bg-primary" />
          <span className="organic-dot h-3 w-3 rounded-full bg-primary" />
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, checking } = useAuth();
  if (checking) return null;
  if (user) return <Navigate to="/app" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
            <Route path="/app" element={<Protected><AppLayout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="invest" element={<InvestPlan />} />
              <Route path="portfolio" element={<Investments />} />
              <Route path="goals" element={<Goals />} />
              <Route path="assistant" element={<Copilot />} />
              <Route path="activity" element={<Transactions />} />
              <Route path="reports" element={<Reports />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
        <ContestPopup />
      </AuthProvider>
    </div>
  );
}

export default App;
